import { css } from 'styled-components';

// CircularSTD
import bookWoff from 'static/fonts/circular-std/book.woff';
import bookWoff2 from 'static/fonts/circular-std/book.woff2';
import mediumWoff from 'static/fonts/circular-std/medium.woff';
import mediumWoff2 from 'static/fonts/circular-std/medium.woff2';
import boldWoff from 'static/fonts/circular-std/bold.woff';
import boldWoff2 from 'static/fonts/circular-std/bold.woff2';

// Icons
import iconEot from 'static/fonts/icon/font.eot';
import iconTtf from 'static/fonts/icon/font.ttf';
import iconWoff from 'static/fonts/icon/font.woff';
import iconSvg from 'static/fonts/icon/font.svg';

import { font } from './mixins';

export default css`
  ${font({ woff: bookWoff,   woff2: bookWoff2 },   'CircularStd', 400)}
  ${font({ woff: mediumWoff, woff2: mediumWoff2 }, 'CircularStd', 500)}
  ${font({ woff: boldWoff,   woff2: boldWoff2 },   'CircularStd', 600)}
  ${font({ woff: iconWoff, eot: iconEot, ttf: iconTtf, svg: iconSvg }, 'Icon Font')}
`;
